export const workspace = {
  routes: [
    {
      path: "/workspace/library/processing-adjective",
      component: () => import("../workspace-library-processing-adjective-view"),
    },
  ],
};
export const management = {
  routes: [
    {
      path: "/management/processing-adjective",
      component: () => import("../management-library-processing-adjective-view"),
    },
  ],
};
